import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ChatAbusePreview,
  ChatAbusePreviewRequest,
  ChatAbuseReceipt,
  ChatAbuseSubmission,
} from '../models/chat-abuse-report.model';

export interface IChatAbuseReportRepository {
  previewAbuseReport(request: ChatAbusePreviewRequest): Observable<ChatAbusePreview>;
  submitAbuseReport(request: ChatAbuseSubmission): Observable<ChatAbuseReceipt>;
  getAbuseReportReceipt(reportId: string): Observable<ChatAbuseReceipt>;
}

export const CHAT_ABUSE_REPORT_REPOSITORY = new InjectionToken<IChatAbuseReportRepository>(
  'IChatAbuseReportRepository',
);
